export function calculatePoints(point, stage) {
  if (!point || !stage) {
    return { x: 0, y: 0 };
  }
  const scale = stage.scaleX();
  const newPoint = {
    x: (point.x - stage.x()) / scale,
    y: (point.y - stage.y()) / scale,
  };
  return newPoint;
}
